import React from "react";
import { Route, Switch } from "react-router-dom";

import { OrganizationProvider } from "contextProviders/organization/OrganizationProvider";

// Fulfillment
import OrganizationDetailsPageOld, {
  OrganizationDetailsPage,
} from "pages/_common/organization/OrganizationDetailsPage";
import FulfillmentOrderCreatePage from "pages/fulfillment/FulfillmentOrderCreatePage";
import FulfillmentOrderCreateViaCsvPage from "pages/fulfillment/FulfillmentOrderCreateViaCsvPage";
import { FulfillmentOrderIndexPage } from "pages/fulfillment/FulfillmentOrderIndexPage";
import SyncOrderWithShopifyPage from "pages/fulfillment/SyncOrderWithShopifyPage";
import InventoryTransferIndexPage from "pages/fulfillment/InventoryTransferIndexPage";
import InventoryTransferCreatePage from "pages/fulfillment/InventoryTransferCreatePage";
import InventoryTransferDetailsPage from "pages/fulfillment/InventoryTransferDetailsPage";

// Organization
import OrganizationRateCardIndexPage from "pages/_common/organization/OrganizationRateCardIndexPage";
import OrganizationUsersRouter from "routes/OrganizationUsersRouter";
import OrganizationUserRolesRouter from "routes/OrganizationUserRolesRouter";
import OrganizationCarriersRouter from "routes/OrganizationCarriersRouter";
import OrganizationStorePage from "pages/_common/organization/OrganizationStorePage";
import OrganizationCreateEditPage from "pages/_common/organization/OrganizationCreateEditPage";
import FulfillmentProductRouter from "routes/FulfillmentProductRouter";
import ShipmentIndexPage from "pages/fulfillment/ShipmentIndexPage";
import FulfillmentASNIndexPage from "pages/fulfillment/FulfillmentASNIndexPage";
import FulfillmentWROIndexPage from "pages/fulfillment/FulfillmentWROIndexPage";
import ReturnsRouter from "routes/ReturnsRouter";
import OrganizationEventSubscriptionRouter from "routes/OrganizationEventSubscriptionsRouter";

/**
 * Organization sub-router
 */
const OrganizationDetailsRouter = () => {
  return (
    <OrganizationProvider>
      <Switch>
        <Route exact path="/organizations/:organization_id" component={OrganizationDetailsPage} />
        <Route exact path="/organizations/:organization_id/old-ui" component={OrganizationDetailsPageOld} />
        <Route path="/organizations/:organization_id/edit" component={OrganizationCreateEditPage} />
        <Route path="/organizations/:organization_id/rate-card" component={OrganizationRateCardIndexPage} />
        <Route path="/organizations/:organization_id/stores" component={OrganizationStorePage} />
        <Route path="/organizations/:organization_id/sync-order-with-shopify" component={SyncOrderWithShopifyPage} />

        <Route
          path="/organizations/:organization_id/orders/create-via-csv"
          component={FulfillmentOrderCreateViaCsvPage}
        />

        <Route path="/organizations/:organization_id/orders/create" component={FulfillmentOrderCreatePage} />
        <Route
          path="/organizations/:organization_id/orders"
          component={FulfillmentOrderIndexPage}
          key="organization-orders"
        />

        <Route
          path="/organizations/:organizationID/shipments"
          component={ShipmentIndexPage}
          key="organization-shipment"
        />

        <Route path="/organizations/:organization_id/asns" component={FulfillmentASNIndexPage} />
        <Route path="/organizations/:organization_id/wros" component={FulfillmentWROIndexPage} />

        <Route path="/organizations/:organization_id/products" component={FulfillmentProductRouter} />
        <Route exact path="/organizations/:organization_id/transfers" component={InventoryTransferIndexPage} />
        <Route path="/organizations/:organization_id/transfers/create" component={InventoryTransferCreatePage} />
        <Route path="/organizations/:organization_id/transfers/:transferId" component={InventoryTransferDetailsPage} />

        <Route path="/organizations/:organization_id/users" component={OrganizationUsersRouter} />
        <Route path="/organizations/:organization_id/roles" component={OrganizationUserRolesRouter} />
        <Route path="/organizations/:organization_id/carriers" component={OrganizationCarriersRouter} />
        <Route path="/organizations/:organization_id/returns" component={ReturnsRouter} />
        <Route
          path="/organizations/:organization_id/event-subscriptions"
          component={OrganizationEventSubscriptionRouter}
        />
      </Switch>
    </OrganizationProvider>
  );
};

export default OrganizationDetailsRouter;
